import styled from 'styled-components';

export const Root = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1003;
`;
